module.exports = __webpack_public_path__ + "img/icon-implantation-02.d24a18e1.svg";